import * as React from "react";

interface HtmlQuestionProps {
  question: any;
}

class HtmlQuestion extends React.Component<HtmlQuestionProps, {}> {
  el: any;

  componentDidMount() {
    this.fixHyperlinks();
  }

  /**
   * If a customer includes a hyperlink in this question, they
   * definitely don't want it to open within the iframe. We'll
   * make sure target="_blank" is applied as a safeguard.
   */
  fixHyperlinks() {
    const links = this.el.getElementsByTagName("a");

    Array.prototype.forEach.call(links, (link: any) => {
      link.target = "_blank";
    });
  }

  render() {
    return (
      <div
        ref={el => (this.el = el)}
        dangerouslySetInnerHTML={{ __html: this.props.question.Html }}
      />
    );
  }
}

export default HtmlQuestion;
